module.exports = "<h2>Type Aliases</h2><pre><code class=\"lang-kotlin\">class CurrentContextManagementInterface {}\n\nval valueA: CurrentContextManagementInterface = ..\n<div class=\"fragment\">\nvalueA is CurrentContextManagementInterface       // true</div><div class=\"fragment\">\ntypealias CtxMgr = CurrentContextManagementInterface</div><div class=\"fragment\">\nvalueA is CtxMgr                                  // true\n</div></code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-moar/07.pug
// module id = 337
// module chunks = 1